"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathLiteral = void 0;
var pathLiteral = function (path) {
    return path.reduce(function (previous, current) {
        var currentType = typeof current;
        if (currentType === 'number' || currentType === 'symbol') {
            return previous + "[" + current + "]";
        }
        else if (currentType === 'string') {
            return previous.length === 0 ? current : previous + "." + current;
        }
        else {
            throw new Error("Unsupported path type: " + current);
        }
    }, '');
};
exports.pathLiteral = pathLiteral;
